<template>
	<div class="FBMOrder">
		<div class="FBMOrder_top">
			<h3>订单管理</h3>
		</div>
		<el-form
			:model="ruleForm"
			ref="ruleForm"
			:label-position="labelPosition"
			label-width="5.8vw"
			inline
			class="custom-formScreen"
		>
			<el-form-item
				label="选择分公司"
				prop="branchCompany"
				v-if="
					[1].includes(str.type) &&
						str.superDepartmentName !== '客服部' &&
						str.superDepartmentName !== '常规客服部'
				"
			>
				<!-- @change="shopChange6" -->
				<el-select
					v-model="value6"
					placeholder="请选择"
					value-key="company_id"
					filterable
				>
					<el-option
						v-for="item in arr6"
						:key="item.company_id"
						:label="item.companyName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				label="选择子公司"
				prop="sonCompany"
				v-if="[2, 1].includes(str.type)"
			>
				<!-- @change="shopChange7" -->
				<el-select
					v-model="value7"
					placeholder="请选择"
					value-key="rid"
					@change="ChangeChild"
					filterable
				>
					<el-option
						v-for="item in arr7"
						:key="item.company_id"
						:label="item.companyName"
						:value="item.company_id"
					></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="选择部门">
                    <el-select
                        v-model="value1"
                        placeholder="请选择"
                        @change="shopChange1"
                        v-bind:disabled="disabledInput"
                    >
                        <el-option
                            v-for="item1 in this.arr"
                            :key="item1.value"
                            :label="item1.departmentName"
                            :value="item1"
                        ></el-option>
                    </el-select>
                </el-form-item>-->

			<!-- <el-form-item label="选择分部门" v-if="!disabledInput2">
				
				<el-select v-model="value2" @change="shopChange2" placeholder="请选择">
					<el-option
						v-for="item2 in this.arr1"
						:key="item2.value"
						:label="item2.departmentName"
						:value="item2"
					></el-option>
				</el-select>
			</el-form-item> -->

			<!-- <el-form-item label="选择组" v-if="!disabledInput3">
				
				<el-select v-model="value3" @change="shopChange3" placeholder="请选择">
					<el-option
						v-for="item3 in this.arr2"
						:key="item3.value"
						:label="item3.groupName"
						:value="item3"
					></el-option>
				</el-select>
			</el-form-item> -->

			<!-- <el-form-item label="选择员工" v-if="!disabledInput4">
				
				<el-select v-model="value4" @change="shopChange4" placeholder="请选择">
					<el-option
						v-for="item4 in this.arr3"
						:key="item4.value"
						:label="item4.roleUserName"
						:value="item4"
					></el-option>
				</el-select>
			</el-form-item> -->
			<!-- <el-form-item label="选择店铺" prop="shopvalue">
				<el-select
					v-model="value5"
					placeholder="请选择"
					@change="shopChange5"
				>
					<el-option
						v-for="item5 in this.arr4"
						:key="item5.value"
						:label="item5.shopName"
						:value="item5"
						:style="{ color: item5.state === 0 ? 'red' : '' }"
					></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item label="采购需求状态" prop="purchaseDemandValue">
				<el-select
					v-model="ruleForm.demandValue"
					placeholder="请选择"
					@change="changeDemand"
				>
					<el-option
						v-for="(item, index) in demandValue"
						:key="index"
						:label="item.label"
						:value="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="亚马逊订单状态" prop="Ymxvalue">
				<el-select
					@change="chanPurchase"
					v-model="ruleForm.Ymxvalue"
					placeholder="请选择"
				>
					<el-option
						v-for="(item, index) in Ymxpurchase"
						:key="index"
						:label="item.label"
						:value="item.label"
					></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item label="国际物流" prop="channelStatus">
				<el-select
					@change="chanDomestic"
					v-model="ruleForm.channelStatus"
					placeholder="请选择"
				>
					<el-option
						v-for="(item, index) in domestic1"
						:key="index"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="国内物流" prop="domesticvalue">
				<el-select
					@change="chanDomestic"
					v-model="ruleForm.domesticvalue"
					placeholder="请选择"
				>
					<el-option
						v-for="(item, index) in domestic"
						:key="index"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开始日期" prop="starttime">
				<el-date-picker
					v-model="ruleForm.starttime"
					align="right"
					type="datetime"
					@change="startTime"
					placeholder="选择日期"
					format="yyyy-MM-dd HH:mm:ss"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="结束日期" prop="endtime">
				<el-date-picker
					v-model="ruleForm.endtime"
					align="right"
					type="datetime"
					@change="endTime"
					placeholder="选择日期"
					format="yyyy-MM-dd HH:mm:ss"
				></el-date-picker>
			</el-form-item>
			<el-row>
				<el-form-item label="国际运单" prop="endtime">
					<el-input
						placeholder="请输入国际运单"
						v-model.trim="ruleForm.conveyNumber"
					></el-input>
				</el-form-item>
				<el-form-item label="国内运单" prop="endtime">
					<el-input
						placeholder="请输入国内运单"
						v-model.trim="ruleForm.internalConveyNumber"
					></el-input>
				</el-form-item>
				<el-form-item label="SKU" prop="sku">
					<el-input
						placeholder="SKU"
						v-model="ruleForm.sku"
					></el-input>
				</el-form-item>
				<el-form-item
					prop="input"
					label="订单ID/订单号"
					style="width: 40%"
				>
					<el-input
						v-model.trim="input"
						style="width: calc(100% - 140px);"
						placeholder="请输入订单ID、订单号"
					></el-input>
					<el-button
						type="primary"
						style="margin-left: 10px;"
						@click="Search2"
						>搜索</el-button
					>
					<el-button type="primary" @click="searchReset"
						>重置</el-button
					>
				</el-form-item>
			</el-row>
			<el-form-item label="订单状态：" style="width:100%;">
				<el-radio-group
					v-model="ruleForm.resource1"
					@change="radiochange1"
				>
					<template v-for="item in this.colorList1">
						<el-radio :key="item.id" :label="item.itemTypeId">{{
							item.itemTypeName
						}}</el-radio>
					</template>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="国际运单状态：" style="width:100%;">
				<el-radio-group
					v-model="ruleForm.resource3"
					@change="radiochange3"
				>
					<template v-for="item in this.colorList3">
						<el-radio
							:key="item.id"
							:label="item.itemTypeId"
							v-if="
								item.itemTypeId == 1 ||
									item.itemTypeId == 2 ||
									item.itemTypeId == 3 ||
									item.itemTypeId == 4 ||
									item.itemTypeId == 5 ||
									item.itemTypeId == 6 ||
									item.itemTypeId == 7 ||
									item.itemTypeId == 8 ||
									item.itemTypeId == 9 ||
									item.itemTypeId == 10 ||
									item.itemTypeId == 11 ||
									item.itemTypeId == 12
							"
							>{{ item.itemTypeName }}</el-radio
						>
					</template>
				</el-radio-group>
			</el-form-item>

			<el-form-item style="width:100%;">
				<el-tooltip
					class="item"
					effect="dark"
					content="该功能可与海逊渠道部沟通国际物流相关问题"
					placement="top"
				>
					<label class="el-form-item__label" style="width:120px;"
						>运单更新状态：</label
					>
				</el-tooltip>
				<el-radio-group
					v-model="ruleForm.resource3"
					@change="radiochange3"
				>
					<template v-for="item in this.colorList3">
						<el-radio
							:key="item.id"
							:label="item.itemTypeId"
							v-if="
								item.itemTypeId == 13 ||
									item.itemTypeId == 14 ||
									item.itemTypeId == 15 ||
									item.itemTypeId == 16 ||
									item.itemTypeId == 17
							"
							>{{ item.itemTypeName }}</el-radio
						>
					</template>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="国内运单状态：" style="width:100%;">
				<el-radio-group
					v-model="ruleForm.resource2"
					@change="radiochange2"
				>
					<template v-for="item in this.colorList2">
						<el-radio :key="item.id" :label="item.itemTypeId">{{
							item.itemTypeName
						}}</el-radio>
					</template>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="查漏选择：" style="width:100%;">
				<el-radio-group v-model="radioTime" @change="radioChangeTime">
					<el-radio label="3-7">国内采购（3-7天）</el-radio>
					<el-radio label="8-11">国际发货（8-11天）</el-radio>
					<el-radio label="25">国际到达（25天以上）</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>

		<!-- 添加loading -->
		<div
			class="order_list"
			v-loading="loading"
			element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
		>
			<div class="search-result oh">
				<p class="search-result-text">
					符合条件的订单共有
					<span>{{ total || 0 }}</span>
					个
				</p>
				<el-row
					class="right"
					type="flex"
					justify="flex-endd"
					align="middle"
				>
					<div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand1">
							<el-button type="primary" :disabled="colordisabled">
								订单状态标记<i
									class="el-icon-arrow-down el-icon--right"
								></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList1">
									<el-dropdown-item
										:command="item.itemTypeId"
										>{{
											item.itemTypeName
										}}</el-dropdown-item
									>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand3">
							<el-button type="primary" :disabled="colordisabled">
								国际运单标记<i
									class="el-icon-arrow-down el-icon--right"
								></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList3">
									<el-dropdown-item
										:command="item.itemTypeId"
										v-if="
											item.itemTypeId == 1 ||
												item.itemTypeId == 2 ||
												item.itemTypeId == 3 ||
												item.itemTypeId == 4 ||
												item.itemTypeId == 5 ||
												item.itemTypeId == 6 ||
												item.itemTypeId == 7 ||
												item.itemTypeId == 8 ||
												item.itemTypeId == 9 ||
												item.itemTypeId == 10 ||
												item.itemTypeId == 11 ||
												item.itemTypeId == 12 ||
												item.itemTypeId == 15 ||
												item.itemTypeId == 16 ||
												item.itemTypeId == 17
										"
										>{{
											item.itemTypeName
										}}</el-dropdown-item
									>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div style="margin-right:20px;">
						<el-dropdown trigger="click" @command="handleCommand2">
							<el-button type="primary" :disabled="colordisabled">
								国内运单标记<i
									class="el-icon-arrow-down el-icon--right"
								></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList2">
									<el-dropdown-item
										:command="item.itemTypeId"
										>{{
											item.itemTypeName
										}}</el-dropdown-item
									>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div
						style="margin-right: 20px;color: rgb(96, 98, 102);font-size: 14px;line-height: 40px;"
					>
						可用金额：{{ companyInfo.buckleBalance }}
					</div>
					<div
						style="margin-right: 20px;color: rgb(96, 98, 102);font-size: 14px;line-height: 40px;"
					>
						实际金额：{{ companyInfo.balance }}
					</div>
					<template v-if="str.type === 3">
						<!-- <el-button type="primary" @click="handleUpload">
							上传运单
						</el-button> -->
						<el-button
							v-if="str.superDepartmentName === '运营部'"
							type="primary"
							@click="handleSync"
						>
							新增订单
						</el-button>
					</template>
				</el-row>
			</div>

			<el-table
				border
				:header-cell-style="{ textAlign: 'center' }"
				:data="tableData"
				style="width: 100%;margin-bottom:50px;"
				@selection-change="handleSelectionChange"
				v-loading="loadingStatus"
			>
				<el-table-column
					type="selection"
					width="55"
					align="center"
				></el-table-column>
				<el-table-column label="订单号/订单ID" width="200">
					<template slot-scope="scope">
						<p>订单号：{{ scope.row.amazonOrderId }}</p>
						<p>订单ID：{{ scope.row.id }}</p>
						<el-row type="flex" align="middle">
							<el-tag
								style="margin-right:5px;"
								v-for="tag in scope.row.orderMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
							<el-tag
								style="margin-right:5px;"
								v-if="scope.row.outInterceptStatus == 1"
								color="red"
								effect="dark"
								size="mini"
							>
								拦截
							</el-tag>
							<el-tooltip
								class="item"
								effect="dark"
								content="订单冻结"
								placement="bottom"
								v-if="scope.row.isFreeze === 1"
							>
								<i
									class="element-icons hx-snow"
									style="font-size: 40px;color: #1296db;line-height: 40px;"
								></i>
							</el-tooltip>
							<el-tooltip
								class="item"
								effect="dark"
								content="订单解冻"
								placement="bottom"
								v-if="scope.row.isFreeze === 2"
							>
								<img
									width="40px"
									height="40px"
									src="../../assets/imags/sun.png"
									alt=""
								/>
								<!-- <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i> -->
							</el-tooltip>
							<el-popover
								v-if="scope.row.orderRemarks.length != 0"
								style="display:flex;"
								placement="top-start"
								trigger="hover"
							>
								<h3>订单备忘录</h3>
								<div v-for="item in scope.row.orderRemarks">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span
									>: <span>{{ item.remarkContent }}</span
									>--
									<span>{{ item.createTime }}</span>
								</div>
								<img
									class="Memo"
									slot="reference"
									src="../../assets/imags/备忘录.png"
									alt=""
								/>
							</el-popover>
							<el-popover
								v-if="scope.row.channelRemarks.length != 0"
								style="display:flex;"
								placement="top-start"
								trigger="hover"
							>
								<h3>渠道备忘录</h3>
								<div v-for="item in scope.row.channelRemarks">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span
									>: <span>{{ item.remarkContent }}</span
									>--
									<span>{{ item.createTime }}</span>
								</div>
								<img
									class="Memo1"
									slot="reference"
									src="../../assets/imags/备忘录1.png"
									alt=""
								/>
							</el-popover>
						</el-row>
					</template>
				</el-table-column>

				<el-table-column align="left" label="产品信息" width="250">
					<template slot-scope="scope">
						<div
							class="details"
							v-for="(item, index) in scope.row.orderItems"
							:key="index"
						>
							<div class="details_left">
								<el-popover
									trigger="hover"
									placement="right"
									prop="orderItems.imageUrl"
									v-if="item.imageUrl"
								>
									<img
										:src="item.imageUrl"
										alt
										style="width:500px;height:500px;"
									/>
									<div class="scope_img" slot="reference">
										<img :src="item.imageUrl" alt />
									</div>
								</el-popover>
								<el-button
									type="text"
									size="mini"
									v-else
									@click="getOriginalImg(item)"
									style="padding: 0;"
									>查看原图</el-button
								>
							</div>
							<div class="details_right">
								<div
									style="width: 100%;"
									v-if="scope.row.money == null"
								>
									price: - -
								</div>
								<div
									style="width: 100%;"
									v-if="scope.row.money !== null"
								>
									price: {{ item.itemAmount }}
									{{ item.itemCurrencyCode }}
								</div>
								<div style="width: 100%;">
									SKU: {{ item.sellerSKU }}
								</div>
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="成本(￥)" width="80" align="center">
					<template slot-scope="scope">
						<span
							v-if="scope.row.costPrice < 0"
							style="color:red;"
							>{{ scope.row.costPrice }}</span
						>
						<span v-if="scope.row.costPrice >= 0">{{
							scope.row.costPrice
						}}</span>
					</template>
				</el-table-column>
				<el-table-column label="利润(￥)" width="80" align="center">
					<template slot-scope="scope">
						<div
							v-if="calcProfitPrice(scope.row) < 0"
							style="color:red;"
						>
							{{ calcProfitPrice(scope.row) }}
						</div>
						<div v-if="calcProfitPrice(scope.row) >= 0">
							{{ calcProfitPrice(scope.row) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="下单时间"
					prop="purchaseDate"
					align="center"
				></el-table-column>
				<!-- <el-table-column
					label="店铺"
					prop="countryMarks.countryName"
					align="center"
				></el-table-column>
				<el-table-column
					label="订单状态"
					prop="orderStatus"
					align="center"
					width="80"
				>
					<template slot-scope="scope">
						<div v-if="scope.row.orderStatus === '未发货'">
							<span style="color:red">{{
								scope.row.orderStatus
							}}</span>
						</div>
						<div v-if="scope.row.orderStatus != '未发货'">
							<span>{{ scope.row.orderStatus }}</span>
						</div>
					</template>
				</el-table-column> -->

				<el-table-column label="国际运单" width="260" align="center">
					<template slot-scope="scope">
						<template
							v-for="(item, index) in scope.row.orderChannels"
						>
							<el-popover
								:disabled="!scope.row.queryTrackSwitch"
								placement="left"
								width="500"
								trigger="hover"
								:open-delay="1000"
								:key="index"
								@show="popoverShow('international', item)"
							>
								<template>
									<div
										style="width: 100%;text-align: center;"
										v-if="popoverStatus"
									>
										{{ popoverText }}
									</div>
									<div style="width: 100%;" v-else>
										<div style="margin-bottom: 10px;">
											<span
												>运单号：{{
													popoverInfo.nu
												}}</span
											>
											<span style="margin-left: 10px;">{{
												popoverDomesticOrderStatus[
													popoverInfo.state
												]
											}}</span>
										</div>
										<div
											style="height: 300px;overflow: auto;"
										>
											<div
												v-for="(item,
												index) in popoverInfo.data"
												:key="index"
												style="margin-bottom: 5px;"
											>
												<div>{{ item.context }}</div>
												<div>到达区域: {{ item.areaName }}</div>
												<div>{{ item.time }}</div>
											</div>
										</div>
									</div>
								</template>
								<template slot="reference">
									<el-row
										type="flex"
										justify="center"
										align="middle"
									>
										<div
											style="cursor: pointer;position:relative;z-index:1"
											@click="queryExternalcall(item)"
										>
											<span
												:id="item.conveyNumber"
												:style="{
													color: item.isActive
														? '#51c4d3'
														: '',
												}"
												>{{
													item.conveyNumber + '：'
												}}</span
											>
										</div>
										<span
											:style="{
												color:
													internationalOrderStatus[
														item.status
													].color,
											}"
										>
											{{
												internationalOrderStatus[
													item.status
												].title
											}}
										</span>
									</el-row>
								</template>
							</el-popover>
						</template>
						<!-- <el-row type="flex" justify="center" align="middle" v-for="(item, index) in scope.row.orderChannels" :key="index">
                            <div style="cursor: pointer;" @click="queryExternalcall(item)">
                                <span :id="item.conveyNumber" :style="{ color: item.isActive ? '#51c4d3' : '' }">{{ item.conveyNumber + '：' }}</span>
                            </div>
                            <span v-if="item.status == 0" style="color:blue;">未处理</span>
                            <span v-else-if="item.status == 1" style="color:red;">作废</span>
                            <span v-else-if="item.status == 2" style="color:blue;">未发货</span>
                            <span v-else-if="item.status == 3" style="color:blue;">未发货</span>
                            <span v-else-if="item.status == 4" style="color:green;">已发货</span>
                        </el-row> -->
						<div>
							<el-tag
								style="margin-left:5px;"
								closable
								@close="handleClose2(scope.row, tag)"
								v-for="tag in scope.row.channelMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="国内运单" width="260" align="center">
					<template slot-scope="scope">
						<template v-for="(item, index) in scope.row.purchases">
							<el-popover
								:disabled="!scope.row.queryTrackSwitch"
								placement="left"
								width="500"
								trigger="hover"
								:open-delay="1000"
								:key="index"
								@show="popoverShow('domestic', item)"
							>
								<template>
									<div
										style="width: 100%;text-align: center;"
										v-if="popoverStatus"
									>
										{{ popoverText }}
									</div>
									<div style="width: 100%;" v-else>
										<div style="margin-bottom: 10px;">
											<span
												>运单号：{{
													popoverInfo.nu
												}}</span
											>
											<span style="margin-left: 10px;">{{
												popoverDomesticOrderStatus[
													popoverInfo.state
												]
											}}</span>
										</div>
										<div
											style="height: 300px;overflow: auto;"
										>
											<div
												v-for="(item,
												index) in popoverInfo.data"
												:key="index"
												style="margin-bottom: 5px;"
											>
												<div>{{ item.context }}</div>
												<div>到达区域: {{ item.areaName }}</div>
												<div>{{ item.time }}</div>
											</div>
										</div>
									</div>
								</template>
								<template slot="reference">
									<el-row
										type="flex"
										justify="center"
										align="middle"
									>
										<div
											style="cursor: pointer;"
											@click="
												queryDomesticOrderClick(item)
											"
										>
											<span
												:style="{
													color: item.isActive
														? '#51c4d3'
														: '',
												}"
												>{{
													item.internalConveyNumber +
														'：'
												}}</span
											>
										</div>
										<span
											:style="{
												color:
													domesticOrderStatus[
														item.purchaseStatus
													].color,
											}"
										>
											{{
												domesticOrderStatus[
													item.purchaseStatus
												].title
											}}
										</span>
									</el-row>
								</template>
							</el-popover>
						</template>
						<!-- <div v-for="item in scope.row.purchases">
                            <span>{{item.internalConveyNumber}}</span>:
                            <span v-if="item.purchaseStatus == 1" style="color:#f04b22;">待采购</span>
                            <span v-if="item.purchaseStatus == 2" style="color:#1677b3;">已采购</span>
                            <span v-if="item.purchaseStatus == 3" style="color:#12a182;">已发货</span>
                            <span v-if="item.purchaseStatus == 4" style="color:#835e1d;">已签收</span>
                            <span v-if="item.purchaseStatus == 5" style="color:#a8456b;">退货</span>
                        </div> -->
						<div>
							<el-tag
								style="margin-left:5px;"
								closable
								@close="handleClose1(scope.row, tag)"
								v-for="tag in scope.row.purchaseMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="采购需求状态" width="60" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.purchaseDemandStatus == '未完成'">
							<span style="color:red">{{
								scope.row.purchaseDemandStatus
							}}</span>
						</div>
						<div v-if="scope.row.purchaseDemandStatus == '已完成'">
							<span>{{ scope.row.purchaseDemandStatus }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="数量"
					prop="quantityOfOrdered"
					width="60"
					align="center"
				></el-table-column>
				<el-table-column
					label="操作"
					width="80"
					fixed="right"
					align="center"
				>
					<template slot-scope="scope">
						<div
							style="text-align: center;padding: 20px;"
							@click="operation(scope.row)"
						>
							<i
								style="font-size: 20px;"
								class="el-icon-edit-outline"
							></i>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="page">
				<el-pagination
					style="margin-right:200px;"
					layout="total, sizes, prev, pager, next, jumper"
					:page-sizes="[20, 50, 100, 200, 400]"
					:page-size="size"
					:current-page="currentpage"
					:total="total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</div>
		<FBModeredit ref="editpanel" @edit="edit" :rate="rate"></FBModeredit>
		<Waybill ref="Waybill" />

		<!-- 新增订单 -->
		<el-dialog
			title="新增订单"
			:visible.sync="NewAddDialog"
			width="40%"
			top="30px"
		>
			<div class="el-form-item">
				<label class="el-form-item__label" style="width: 80px;"
					>订单号：
				</label>
				<div class="el-form-item__content" style="margin-left: 80px;">
					<div class="el-input">
						<input
							type="text"
							v-model="addOrderForm.amazonOrderId"
							class="el-input__inner"
						/>
					</div>
				</div>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label" style="width: 80px;"
					>买家邮箱：
				</label>
				<div class="el-form-item__content" style="margin-left: 80px;">
					<div class="el-input" style="width:210px">
						<input
							type="text"
							v-model="addOrderForm.buyerEmail"
							class="el-input__inner"
						/>
					</div>
				</div>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label" style="width: 80px;"
					>选择货币：
				</label>
				<el-select
					style="width:210px"
					v-model="addOrderForm.itemCurrencyCode"
					placeholder="请选择货币"
				>
					<el-option
						v-for="(stem, i) in SelectCurrency"
						:key="i"
						:label="stem.label"
						:value="stem.value"
					>
					</el-option>
				</el-select>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label" style="width: 80px;"
					>下单时间：
				</label>
				<el-date-picker
					format="yyyy-MM-dd HH:mm:ss"
					v-model="addOrderForm.purchaseDate"
					type="datetime"
					placeholder="选择日期时间"
				>
				</el-date-picker>
			</div>
			<div
				class="NewAddsTopBox"
				v-for="(item, i) in addOrderForm.orderItems"
				:key="i"
				@click="GetIndex(i)"
			>
				<div class="NewAddsTop">
					<p class="OrderTit">订单详情{{ i + 1 }}</p>
					<p class="Remove" v-if="i > 0">
						<i
							@click="Remove_Per(i)"
							class="el-icon-circle-close"
						></i>
					</p>
				</div>

				<div class="NewAddsTop">
					<div class="LeftUp">
						<el-upload
							:action="action"
							:headers="customHeaders"
							class="avatar-uploader"
							:show-file-list="false"
							:on-success="handleAvatarSuccess"
						>
							<img
								v-if="item.imageUrl"
								:src="item.imageUrl"
								class="avatar"
							/>
							<i
								v-else
								class="el-icon-plus avatar-uploader-icon"
							></i>
						</el-upload>
						<span>上传图片</span>
					</div>
					<div class="RightInp">
						<div class="el-form-item">
							<label
								class="el-form-item__label"
								style="width: 80px;"
								>销售链接：
							</label>
							<div
								class="el-form-item__content"
								style="margin-left: 80px;width:400px"
							>
								<div class="el-input">
									<input
										type="text"
										class="el-input__inner"
										v-model="item.saleLink"
									/>
								</div>
							</div>
						</div>
						<div class="el-form-item">
							<label
								class="el-form-item__label"
								style="width: 80px;"
								>数量：
							</label>
							<div
								class="el-form-item__content"
								style="margin-left: 80px;"
							>
								<div class="el-input">
									<input
										type="text"
										class="el-input__inner"
										v-model.number="item.quantityOrdered"
									/>
								</div>
							</div>
						</div>
						<div class="el-form-item">
							<label
								class="el-form-item__label"
								style="width: 80px;"
								>售价：
							</label>
							<div
								class="el-form-item__content"
								style="margin-left: 80px;"
							>
								<div class="el-input">
									<input
										type="text"
										class="el-input__inner"
										v-model.number="item.itemAmount"
									/>
								</div>
							</div>
						</div>
						<div class="el-form-item">
							<label
								class="el-form-item__label"
								style="width: 80px;"
								>SKU：
							</label>
							<div
								class="el-form-item__content"
								style="margin-left: 80px;"
							>
								<div class="el-input">
									<input
										type="text"
										v-model="item.sellerSKU"
										class="el-input__inner"
									/>
								</div>
							</div>
						</div>
						<div class="el-form-item">
							<label
								class="el-form-item__label"
								style="width: 80px;"
								>货源链接：
							</label>
							<div
								class="el-form-item__content"
								style="margin-left: 80px;"
							>
								<el-button
									@click="AddSupply(item)"
									type="primary"
									>添加货源链接</el-button
								>
								<span style="margin-left:10px;color:red">
									{{ item.supply.length }} 条</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-button @click="addition" type="primary">添加订单详情</el-button>
			<div class="NewAddsBottom">
				<div style="margin-bottom: 10px;">
					<label class="el-form-item__label custom">国家 </label>
					<el-select
						v-model="addOrderForm.countryCode"
						filterable
						style="width: 171px"
						placeholder="请选择国家"
					>
						<el-option
							v-for="(item, i) in SelectNation"
							:key="i"
							:label="item.countryName"
							:value="item.countryCode"
						>
						</el-option>
					</el-select>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;margin:0 5px"
						class="el-input-left"
						v-model="addOrderForm.stateOrRegion"
					>
						<template slot="prepend">
							州/省
						</template>
					</el-input>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;"
						class="el-input-left"
						v-model="addOrderForm.city"
					>
						<template slot="prepend">
							城市
						</template>
					</el-input>
				</div>
				<div style="margin-bottom: 10px;">
					<el-input
						placeholder="请输入内容"
						style="width: 220px;"
						v-model="addOrderForm.county"
					>
						<template slot="prepend">
							县
						</template>
					</el-input>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;margin:0 5px"
						class="el-input-left"
						v-model="addOrderForm.district"
					>
						<template slot="prepend">
							区
						</template>
					</el-input>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;"
						class="el-input-left"
						v-model="addOrderForm.municipality"
					>
						<template slot="prepend">
							自治市
						</template>
					</el-input>
				</div>
				<div style="margin-bottom: 10px;">
					<el-input
						placeholder="请输入内容"
						v-model="addOrderForm.name"
						style="width: 220px;"
					>
						<template slot="prepend">
							收件人
						</template>
					</el-input>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;margin:0 5px"
						class="el-input-left"
						v-model="addOrderForm.postalCode"
					>
						<template slot="prepend">
							邮编
						</template>
					</el-input>

					<el-input
						placeholder="请输入内容"
						style="width: 220px;"
						class="el-input-left"
						v-model="addOrderForm.phone"
					>
						<template slot="prepend">
							电话
						</template>
					</el-input>
				</div>
				<div style="margin-bottom: 10px;">
					<el-input
						placeholder="请输入内容"
						v-model="addOrderForm.addressLine1"
						style="width: 670px;"
					>
						<template slot="prepend">
							地址1
						</template>
					</el-input>
				</div>
				<div style="margin-bottom: 10px;">
					<el-input
						placeholder="请输入内容"
						v-model="addOrderForm.addressLine2"
						style="width: 670px;"
					>
						<template slot="prepend">
							地址2
						</template>
					</el-input>
				</div>
				<div>
					<el-input
						placeholder="请输入内容"
						v-model="addOrderForm.addressLine3"
						style="width: 670px;"
					>
						<template slot="prepend">
							地址3
						</template>
					</el-input>
				</div>
			</div>
			<el-dialog
				width="30%"
				title="添加货源"
				:visible.sync="LinkInnerVisible"
				append-to-body
			>
				<el-form>
					<el-form-item label>
						<el-row
							v-for="(item, index) in blue_point"
							:key="index"
						>
							<el-col :span="22" style="position: relative;">
								<el-input
									placeholder="请输入内容"
									v-model="item.url"
									style="padding: 5px 0 0 0;"
								>
									<el-button
										slot="append"
										@click="handleURL(item.url)"
										>访问链接</el-button
									>
								</el-input>
							</el-col>
							<el-col :span="2">
								<el-button
									type="danger"
									@click="edit_blue_del(item, index)"
									icon="el-icon-close"
								></el-button>
							</el-col>
						</el-row>
						<span style="color:#F56C6C">
							<template v-if="blue_point.length">
								此链接记录货源链接，可填写1-5条，非必填。
							</template>
							<template v-else>
								暂无货源链接
							</template>
						</span>
					</el-form-item>
				</el-form>
				<el-button type="primary" @click="edit_blue_point"
					>增加一条记录</el-button
				>
				<div slot="footer" class="dialog-footer">
					<el-button @click="LinkInnerVisible = false"
						>取 消</el-button
					>
					<el-button type="primary" @click="Notarize"
						>确 定</el-button
					>
				</div>
			</el-dialog>
			<span slot="footer" class="dialog-footer">
				<el-button @click="NewAddDialog = false">取 消</el-button>
				<!-- :loading="issloading1" -->
				<el-button type="primary" @click="EnsureAdd">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 上传运单 -->
		<el-dialog
			title="上传运单"
			:visible.sync="uploadWaybillDialog"
			width="60%"
			top="7vh"
		>
			<el-row type="flex" style="margin-bottom:10px;" align="middle">
				<div style="margin-right:10px;">
					<label>请选择站点：</label>
					<el-select
						filterable
						v-model="uploadWaybillShop"
						placeholder="请选择"
						value-key="shopId"
						@change="uploadWaybillShopChange"
					>
						<el-option
							v-for="item in optionsUpload"
							:key="item.shopId"
							:label="`${item.shopName}(${item.countryName})`"
							:value="item"
						></el-option>
					</el-select>
				</div>
				<el-radio-group
					v-model="waybillType"
					size="small"
					@change="handleRadioChange"
				>
					<el-radio-button label="1">运单号</el-radio-button>
					<el-radio-button label="2">转单号</el-radio-button>
				</el-radio-group>

				<el-button
					style="margin:0 15px"
					v-if="waybillType == '2'"
					@click="OneOperation"
					type="primary"
					>渠道同步</el-button
				>
				<span v-if="waybillType == '2'" class="RRR"
					>提示：一键操作前请选择表格第一个</span
				>
			</el-row>
			<el-table
				:data="listTableWaybill"
				border
				:header-cell-style="{ textAlign: 'center' }"
				@selection-change="handleSelectionWaybillChange"
			>
				<el-table-column
					type="selection"
					width="50"
					align="center"
				></el-table-column>
				<el-table-column label="订单号/订单ID" align="left" width="200">
					<template slot-scope="scope">
						<p>订单号：{{ scope.row.amazonOrderId }}</p>
						<p>订单ID：{{ scope.row.orderId }}</p>
						<el-row type="flex" align="middle">
							<el-tag
								style="margin-right:5px;"
								v-for="tag in scope.row.orderMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
							<el-tag
								style="margin-right:5px;"
								v-if="scope.row.outInterceptStatus == 1"
								color="red"
								effect="dark"
								size="mini"
							>
								拦截
							</el-tag>
							<el-tooltip
								class="item"
								effect="dark"
								content="订单冻结"
								placement="bottom"
								v-if="scope.row.isFreeze === 1"
							>
								<i
									class="element-icons hx-snow"
									style="font-size: 40px;color: #1296db;line-height: 40px;"
								></i>
							</el-tooltip>
							<el-popover
								v-if="scope.row.orderRemarks.length != 0"
								style="display:flex;"
								placement="top-start"
								trigger="hover"
							>
								<h3>订单备忘录</h3>
								<div v-for="item in scope.row.orderRemarks">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span
									>: <span>{{ item.remarkContent }}</span
									>--
									<span>{{ item.createTime }}</span>
								</div>
								<img
									class="Memo"
									slot="reference"
									src="../../assets/imags/备忘录.png"
									alt=""
								/>
							</el-popover>
							<el-popover
								v-if="scope.row.channelRemarks.length != 0"
								style="display:flex;"
								placement="top-start"
								trigger="hover"
							>
								<h3>渠道备忘录</h3>
								<div v-for="item in scope.row.channelRemarks">
									<span>{{ item.roleName }}</span>
									<span v-if="item.userName !== null">-</span>
									<span>{{ item.userName }}</span
									>: <span>{{ item.remarkContent }}</span
									>--
									<span>{{ item.createTime }}</span>
								</div>
								<img
									class="Memo1"
									slot="reference"
									src="../../assets/imags/备忘录1.png"
									alt=""
								/>
							</el-popover>
						</el-row>
					</template>
				</el-table-column>
				<el-table-column label="产品信息" align="left" min-width="250">
					<template slot-scope="scope">
						<template v-for="item in scope.row.orderItems">
							<el-row type="flex" :key="item.id">
								<div class="details_left">
									<el-popover
										trigger="hover"
										placement="right"
										prop="orderItems.imageUrl"
									>
										<img
											:src="item.imageUrl"
											style="width: 500px;height: 500px;"
										/>
										<div class="scope_img" slot="reference">
											<img :src="item.imageUrl" />
										</div>
									</el-popover>
								</div>
								<div class="details_right">
									<div
										style="width: 100%;"
										v-if="!item.itemAmount"
									>
										price: - -
									</div>
									<div style="width: 100%;" v-else>
										price: {{ item.itemAmount }}
										{{ item.itemCurrencyCode }}
									</div>
									<div style="width: 100%;">
										SKU: {{ item.sellerSKU }}
									</div>
								</div>
							</el-row>
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="channelName" label="店铺" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.shopName }}</span>
						<span>（{{ scope.row.countryName }}）</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="channelName"
					label="渠道名称"
					align="center"
					width="200"
				>
					<template slot-scope="scope">
						<div v-show="waybillType === '1'">
							<div>{{ scope.row.channelName }}</div>
						</div>
						<div v-show="waybillType === '2'">
							<!--                            <el-input v-model="scope.row.channelName"></el-input>-->
							<el-select
								v-model="scope.row.channelName"
								filterable
								allow-create
								default-first-option
							>
								<el-option
									v-for="(item, index) in listChannel"
									:key="index"
									:label="item.label"
									:value="item.label"
								>
								</el-option>
							</el-select>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="conveyNumber"
					:label="waybillType === '1' ? '运单号' : '转单号'"
					align="center"
					width="160"
				>
					<template slot-scope="scope">
						<div v-show="waybillType === '1'">
							<div>{{ scope.row.conveyNumber }}</div>
						</div>
						<div v-show="waybillType === '2'">
							<div>{{ scope.row.transferOrderNumber }}</div>
							<!-- <el-input v-model="scope.row.transferOrderNumber"></el-input> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-row type="flex" justify="center">
				<el-pagination
					style="margin-top:20px;"
					layout="total, sizes, prev, pager, next, jumper"
					:page-sizes="[20, 50, 100, 200, 500, 1000, 2000]"
					:page-size="waybillSize"
					:current-page="waybillPage"
					:total="waybillTotal"
					@size-change="handleSizeWaybillChange"
					@current-change="handleCurrentWaybillChange"
				></el-pagination>
			</el-row>

			<span slot="footer" class="dialog-footer">
				<el-button @click="uploadWaybillDialog = false"
					>取 消</el-button
				>
				<el-button
					type="primary"
					@click="updateWaybill(1)"
					v-show="waybillType === '1'"
					>上传运单号</el-button
				>
				<el-button
					type="primary"
					@click="updateWaybill(2)"
					v-show="waybillType === '2'"
					>上传转单号</el-button
				>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="originalVisible" width="540px">
			<img
				style="width: 500px;height: 500px;"
				:src="originalImg"
				alt=""
			/>
		</el-dialog>
	</div>
</template>
<script>
let checkedList = []
let timer = null
import './js/externalcall'
import FBModeredit from './FBModeredit/FBModeredit.vue'
import Waybill from './FBModeredit/Waybill'
import { ajaxPost, Baseurl } from '../../api/api/api'
import ListChannel from './data/listChannel.json'

export default {
	name: 'FBMOrder',
	components: {
		FBModeredit,
		Waybill,
	},
	data() {
		return {
			NewAddDialog: false,
			LinkInnerVisible: false,
			blue_point: [],
			SelectNation: [],
			addOrderForm: {
				rid: '',
				amazonOrderId: '',
				purchaseDate: '',
				buyerEmail: '',
				orderItems: [
					{
						saleLink: '',
						quantityOrdered: '',
						itemAmount: '',
						sellerSKU: '',
						imageUrl: '',
						sourceLinks: [],
						supply: [],
					},
				],
				countryCode: '',
				stateOrRegion: '',
				city: '',
				name: '',
				postalCode: '',
				phone: '',
				county: '',
				district: '',
				municipality: '',
				addressLine1: '',
				addressLine2: '',
				addressLine3: '',
			},
			SelectCurrency: [
				{
					value: 'GBP',
					label: '英镑',
				},
				{
					value: 'EUR',
					label: '欧元',
				},
				{
					value: 'USD',
					label: '美元',
				},
				{
					value: 'CAD',
					label: '加元',
				},
				{
					value: 'MXN',
					label: '墨西哥币',
				},
				{
					value: 'JPY',
					label: '日元',
				},
				{
					value: 'AUD',
					label: '澳元',
				},
				{
					value: 'AED',
					label: '阿联酋迪拉姆',
				},
				{
					value: 'SGD',
					label: '新加坡元',
				},
				{
					value: 'INR',
					label: '印度卢比',
				},
				{
					value: 'CNY',
					label: '中国',
				},
				{
					value: 'SEK',
					label: '瑞典',
				},
				{
					value: 'PLN',
					label: '波兰',
				},
				{
					value: 'SAR',
					label: '沙特里亚尔',
				},
				{
					value: 'BRL',
					label: '巴西雷亚尔',
				},
			],

			Tindex: 0,
			action: Baseurl + 'imageController/uploadImage',
			customHeaders: { token: localStorage.getItem('token') },
			state: '',
			// headClass: this.common.headClass,
			labelPosition: 'right',
			sondata: {},
			total: 0,
			// value1: "",
			value2: '',
			value3: '',
			value4: '',
			value5: '',
			select: '',
			tableData: [],
			states: '',
			issloading: false,
			issloading1: false,
			// shop: [{ value: "1", label: "店铺" }],
			domestic: Object.freeze([
				{ label: '待采购', value: '1' },
				{ label: '已采购', value: '2' },
				{ label: '已发货', value: '3' },
				{ label: '已签收', value: '4' },
				{ label: '退货', value: '5' },
				{ label: '在途', value: '6' },
				{ label: '揽收', value: '7' },
				{ label: '疑难', value: '8' },
				{ label: '退签', value: '9' },
				{ label: '派件', value: '10' },
				{ label: '退回', value: '11' },
				{ label: '转投', value: '12' },
				{ label: '待清关', value: '13' },
				{ label: '清关中', value: '14' },
				{ label: '已清关', value: '15' },
				{ label: '清关异常', value: '16' },
				{ label: '拒签', value: '17' },
				{ label: '清关', value: '18' },
				{ label: '已下单', value: '101' },
				{ label: '待揽收', value: '102' },
				{ label: '已揽收', value: '103' },
				{ label: '到达派件城市', value: '1001' },
				{ label: '干线', value: '1002' },
				{ label: '转递', value: '1003' },
				{ label: '投柜或驿站', value: '501' },
				{ label: '本人签收', value: '301' },
				{ label: '派件异常后签收', value: '302' },
				{ label: '代签', value: '303' },
				{ label: '投柜或站签收', value: '304' },
				{ label: '已销单', value: '401' },
				{ label: '超时未签收', value: '201' },
				{ label: '超时未更新', value: '202' },
				{ label: '拒收', value: '203' },
				{ label: '派件异常', value: '204' },
				{ label: '柜或驿站超时未取', value: '205' },
				{ label: '无法联系', value: '206' },
				{ label: '超区', value: '207' },
				{ label: '滞留', value: '208' },
				{ label: '破损', value: '209' },
				{ label: '销单', value: '210' },
			]),

			domestic1: Object.freeze([
				{ label: '未发货', value: '0' },
				{ label: '已发货', value: '4' },
				{ label: '已签收', value: '5' },
				{ label: '在途', value: '6' },
				{ label: '揽收', value: '7' },
				{ label: '疑难', value: '8' },
				{ label: '退签', value: '9' },
				{ label: '派件', value: '10' },
				{ label: '退回', value: '11' },
				{ label: '转投', value: '12' },
				{ label: '待清关', value: '13' },
				{ label: '清关中', value: '14' },
				{ label: '已清关', value: '15' },
				{ label: '清关异常', value: '16' },
				{ label: '拒签', value: '17' },
			]),
			// [
			//     //国内物流
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			//     {
			//         value: "1",
			//         label: "已采购",
			//     },
			//     {
			//         value: "2",
			//         label: "已发货",
			//     },
			//     {
			//         value: "3",
			//         label: "已签收",
			//     },
			//     {
			//         value: "4",
			//         label: "退货",
			//     },
			// ],
			// 亚马逊订单状态
			Ymxpurchase: [
				{
					value: '1',
					label: '已取消',
				},
				{
					value: '2',
					label: '等待中',
				},
				{
					value: '3',
					label: '未发货',
				},
				{
					value: '4',
					label: '已发货',
				},
				{
					value: '5',
					label: '已退款',
				},
			],
			//采购需求状态
			demandValue: [
				{
					value: '1',
					label: '未完成',
				},
				{
					value: '2',
					label: '已完成',
				},
			],
			ruleForm: {
				shopvalue: '', //选择店铺
				Ymxvalue: '', //亚马逊订单状态
				domesticvalue: '', //国内物流
				channelStatus: '', // 国际物流
				starttime: '', //开始时间
				endtime: '', //结束时间
				demandValue: '', //选择采购需求状态

				internalConveyNumber: '', //国内运单
				conveyNumber: '', //国际运单

				resource1: '',
				resource2: '',
				resource3: '',
				sku: '',
			},
			currentpage: 1,
			pagesize: 20,
			input: '',
			searchdata: '',
			size: 20,
			sellerIds: '',
			disabledInput: '',
			disabledInput2: '',
			disabledInput3: '',
			disabledInput4: '',
			arr: '',
			arr1: '',
			arr2: '',
			arr3: '',
			arr4: '',
			arr5: '',
			orderStatus: '',
			shopIds: [],
			loading: false,
			// 判断同步订单按钮是否显示
			show: '',
			options: [],
			value: '',
			value6: '',
			purchaseDemandStatus: '',
			str: '',
			strSeller: '',

			downloadOptions: [],
			downLoadValue: '',

			arr6: [],
			arr7: [],
			value6: '',
			value7: '',
			companyId: '',
			rate: [],
			uploadWaybillDialog: false,
			listTableWaybill: [],
			waybillType: '1',
			waybillPage: 1,
			waybillSize: 20,
			waybillTotal: 0,
			uploadWaybillShop: {},
			companyInfo: '',
			optionsUpload: [],
			multipleSelection: [],
			colorList1: [],
			colorList2: [],
			colorList3: [],
			colordisabled: true,

			purchaseMark: '',
			channelMark: '',
			orderMark: '',
			loadingStatus: false,
			originalImg: '',
			originalVisible: false,
			radioTime: '',
			rid: '',
			popoverText: '查询中...',
			popoverStatus: true,
			popoverInfo: null,
			popoverDomesticOrderStatus: Object.freeze({
				0: '在途',
				1: '揽收',
				2: '疑难',
				3: '签收',
				4: '退签',
				5: '派件',
				6: '退回',
				7: '转投',
				10: '待清关',
				11: '清关中',
				12: '已清关',
				13: '清关异常',
				14: '拒签',
			}),
			domesticOrderStatus: Object.freeze({
				1: { title: '待采购', color: '#f04b22' },
				2: { title: '已采购', color: '#1677b3' },
				3: { title: '已发货', color: '#12a182' },
				4: { title: '已签收', color: '#835e1d' },
				5: { title: '退货', color: '#cc163a' },
				6: { title: '在途', color: '#feba07' },
				7: { title: '揽收', color: '#f97d1c' },
				8: { title: '疑难', color: '#ffa60f' },
				9: { title: '退签', color: '#de1c31' },
				10: { title: '派件', color: '#b7511d' },
				11: { title: '退回', color: '#ec4e8a' },
				12: { title: '转投', color: '#f09c5a' },
				13: { title: '待清关', color: '#619ac3' },
				14: { title: '清关中', color: '#2775b6' },
				15: { title: '已清关', color: '#22a2c3' },
				16: { title: '清关异常', color: '#ef498b' },
				17: { title: '拒签', color: '#c21f30' },
				18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
			}),
			internationalOrderStatus: Object.freeze({
				0: { title: '未发货', color: 'blue' },
				1: { title: '作废', color: 'red' },
				2: { title: '未发货', color: 'blue' },
				3: { title: '未发货', color: 'blue' },
				4: { title: '已发货', color: 'green' },
				5: { title: '已签收', color: '#cc163a' },
				6: { title: '在途', color: '#feba07' },
				7: { title: '揽收', color: '#f97d1c' },
				8: { title: '疑难', color: '#ffa60f' },
				9: { title: '退签', color: '#de1c31' },
				10: { title: '派件', color: '#b7511d' },
				11: { title: '退回', color: '#ec4e8a' },
				12: { title: '转投', color: '#f09c5a' },
				13: { title: '待清关', color: '#619ac3' },
				14: { title: '清关中', color: '#2775b6' },
				15: { title: '已清关', color: '#22a2c3' },
				16: { title: '清关异常', color: '#ef498b' },
				17: { title: '拒签', color: '#c21f30' },
				18: { title: '清关', color: '#c21f30' },
				101: { title: '已下单', color: '#c21f30' },
				102: { title: '待揽收', color: '#c21f30' },
				103: { title: '已揽收', color: '#c21f30' },
				1001: { title: '到达派件城市', color: '#c21f30' },
				1002: { title: '干线', color: '#c21f30' },
				1003: { title: '转递', color: '#c21f30' },
				501: { title: '投柜或驿站', color: '#c21f30' },
				301: { title: '本人签收', color: '#c21f30' },
				302: { title: '派件异常后签收', color: '#c21f30' },
				303: { title: '代签', color: '#c21f30' },
				304: { title: '投柜或站签收', color: '#c21f30' },
				401: { title: '已销单', color: '#c21f30' },
				201: { title: '超时未签收', color: '#c21f30' },
				202: { title: '超时未更新', color: '#c21f30' },
				203: { title: '拒收', color: '#c21f30' },
				204: { title: '派件异常', color: '#c21f30' },
				205: { title: '柜或驿站超时未取', color: '#c21f30' },
				206: { title: '无法联系', color: '#c21f30' },
				207: { title: '超区', color: '#c21f30' },
				208: { title: '滞留', color: '#c21f30' },
				209: { title: '破损', color: '#c21f30' },
				210: { title: '销单', color: '#c21f30' },
			}),
			listChannel: [],
		}
	},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
		this.show = this.str.system
		this.state = this.str.system
		this.companyId = this.str.company_id
		this.rid = this.str.rid
		this.init()
		this.getRate()
		this.getCompanyInfo()

		this.orderTag()
		this.domesticTag()
		this.internationalTag()
		//
	},
	methods: {
		// 删除某一项
		Remove_Per(i) {
			this.addOrderForm.orderItems.splice(i, 1)
		},
		// 删除货源url
		edit_blue_del(item, index) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.blue_point.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!',
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		// 获取下标
		GetIndex(i) {
			this.Tindex = i
		},
		// 打开货源url
		handleURL(url) {
			// alert(url);
			// console.log(url);
			window.open(url)
		},
		// 添加货源
		AddSupply(item) {
			this.LinkInnerVisible = true
			this.blue_point = item.supply
		},
		// 新增订单
		handleSync() {
			this.NewAddDialog = true
		},
		// 重置新增
		BaseAdd() {
			this.addOrderForm = {
				rid: '',
				amazonOrderId: '',
				purchaseDate: '',
				buyerEmail: '',
				orderItems: [
					{
						saleLink: '',
						quantityOrdered: '',
						itemAmount: '',
						sellerSKU: '',
						imageUrl: '',
						sourceLinks: [],
						supply: [],
					},
				],
				countryCode: '',
				stateOrRegion: '',
				city: '',
				name: '',
				postalCode: '',
				phone: '',
				county: '',
				district: '',
				municipality: '',
				addressLine1: '',
				addressLine2: '',
				addressLine3: '',
			}
		},
		// 确认添加
		EnsureAdd() {
			let Time = this.addOrderForm.purchaseDate
			if (Time == null || Time == '') {
				Time = ''
			} else {
				Time =
					new Date(this.addOrderForm.purchaseDate)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.addOrderForm.purchaseDate)
						.toTimeString()
						.substr(0, 8)
			}
			this.addOrderForm.purchaseDate = Time
			if (
				this.addOrderForm.addressLine1 == '' &&
				this.addOrderForm.addressLine2 == '' &&
				this.addOrderForm.addressLine3 == ''
			) {
				this.$message.warning('三个地址最少选填一项')
				return
			}
			this.addOrderForm.rid = this.rid
			this.addOrderForm.orderItems.forEach((item) => {
				let arr = item.supply.map((otem) => {
					return otem.url
				})
				// console.log(arr)
				item.sourceLinks = arr
			})
			// name postalCode(邮编) phone countryCode
			if (this.addOrderForm.countryCode == '') {
				this.$message.error('请选择国家！')
				return
			} else if (this.addOrderForm.name == '') {
				this.$message.error('请填写收件人！')
				return
			} else if (this.addOrderForm.postalCode == '') {
				this.$message.error('请填写邮编！')
				return
			} else if (this.addOrderForm.phone == '') {
				this.$message.error('请输入手机号！')
				return
			}
			// console.log(JSON.parse(JSON.stringify(this.addOrderForm)))
			// return
			let API = Baseurl + 'orderController/insertSelfBuiltOrder'
			ajaxPost(API, this.addOrderForm).then((res) => {
				if (res.data.code == 200) {
					this.Search()
					this.BaseAdd()
					this.$message.success('添加成功')
					this.NewAddDialog = false
				} else {
					this.$message.error(res.data.data)
				}
				// console.log(res)
			})
		},
		// 添加链接
		edit_blue_point(index, method) {
			if (this.blue_point.length < 5) {
				const param = {
					url: '',
				}
				this.blue_point.push(param)
			} else {
				this.$message('此链接记录货源链接最多5条字段')
			}
		},

		Notarize() {
			this.LinkInnerVisible = false
		},
		// 新增订单详情
		addition() {
			this.addOrderForm.orderItems.push({
				saleLink: '',
				quantityOrdered: '',
				itemAmount: '',
				sellerSKU: '',
				imageUrl: '',
				sourceLinks: [],
				supply: [],
			})
		},
		handleAvatarSuccess(res, file) {
			if (file.response.code == 200) {
				this.addOrderForm.orderItems[this.Tindex].imageUrl =
					file.response.data
			}
		},
		OneOperation() {
			// console.log(JSON.parse(JSON.stringify(this.listTableWaybill)))
			if (this.listTableWaybill.length != 0) {
				let sleVal = this.listTableWaybill[0].channelName
				if (sleVal != '') {
					this.listTableWaybill.forEach((item) => {
						item.channelName = sleVal
					})
				} else {
					this.$message.info('一键操作前请为表格第一行选择！')
				}
			}
		},
		handleCommand1(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(Baseurl + 'orderController/updateOrderMark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.init()
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		handleCommand2(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.init()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleCommand3(val) {
			var obj = {
				orderInfos: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderChannelMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.init()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		radiochange1(val) {
			this.orderMark = val
			this.init()
		},
		radiochange2(val) {
			this.purchaseMark = val
			this.init()
		},
		radiochange3(val) {
			this.channelMark = val
			this.init()
		},
		radioChangeTime(val) {
			// 今天的时间和时间戳
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			// 上一天的时间戳
			const beforeTimeStamp = nowTimeStamp - 3600 * 1000 * 24
			let startStamp = ''
			let endStamp = ''
			switch (val) {
				case '3-7':
					startStamp = 3600 * 1000 * 24 * 6
					endStamp = 3600 * 1000 * 24 * 3
					break
				case '8-11':
					startStamp = 3600 * 1000 * 24 * 10
					endStamp = 3600 * 1000 * 24 * 8
					break
				case '25':
					endStamp = 3600 * 1000 * 24 * 25
					break
				default:
					this.ruleForm.starttime = ''
					break
			}
			const endData = new Date(beforeTimeStamp - endStamp)
			const endYear = endData.getFullYear()
			const endMonth = endData.getMonth() + 1
			const endDay = endData.getDate()
			this.ruleForm.endtime = `${endYear}-${endMonth}-${endDay} 23:59:59`

			const startData = new Date(beforeTimeStamp - startStamp)
			const startYear = startData.getFullYear()
			const startMonth = startData.getMonth() + 1
			const startDay = startData.getDate()
			this.ruleForm.starttime = `${startYear}-${startMonth}-${startDay} 00:00:00`
			if (val === '25') this.ruleForm.starttime = ''
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
			if (this.multipleSelection === []) {
				this.colordisabled = true
			} else if (this.multipleSelection.length == 0) {
				this.colordisabled = true
			} else {
				this.colordisabled = false
			}
		},
		handleClose1(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.purchaseMark,
				channelMark: val.channelMark,
				id: val.id,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.Search()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClose2(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.purchaseMark,
				channelMark: val.channelMark,
				id: val.id,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderChannelMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.Search()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		//订单、订单号标签
		orderTag() {
			var obj = { itemCode: 'HYXUN0000010' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList1 = res.data.data
						this.sortByKey(this.colorList1, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国内订单标签
		domesticTag() {
			var obj = { itemCode: 'HYXUN0000011' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList2 = res.data.data
						this.sortByKey(this.colorList2, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国际订单标签
		internationalTag() {
			var obj = { itemCode: 'HYXUN0000012' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList3 = res.data.data
						this.sortByKey(this.colorList3, 'itemTypeIdInteger')
					}
				}
			)
		},
		getRate() {
			ajaxPost(Baseurl + 'rateController/getRate').then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.rate = data
				}
				// console.log(this.rate)
			})
		},
		//关闭编辑页面调用init方法
		edit(data) {
			this.Search()
		},
		init() {
			this.loadingStatus = true
			this.shopIds = this.strSeller.shopIds
			let API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API, {}).then((res) => {
				if (res.data.code == 200) {
					this.SelectNation = res.data.data
				}
			})
			// SelectNation
			this.Search()
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: this.str.rid,
				system: this.str.system,
				companyId: this.str.company_id,
			}).then((res) => {
				this.arr = res.data.data.next
				this.shopIds = this.strSeller.shopIds
				this.changePurchaseStatus(this.tableData)
				const { type: companyType } = this.str
				if (
					companyType === 1 &&
					this.str.superDepartmentName !== '客服部' &&
					this.str.superDepartmentName !== '常规客服部'
				) {
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr6 = res.data.data.next
				} else if (
					companyType === 2 ||
					(companyType === 1 &&
						this.str.superDepartmentName === '客服部') ||
					(companyType === 1 &&
						this.str.superDepartmentName === '常规客服部')
				) {
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr7 = res.data.data.next
					console.log(companyType)
				} else if (
					this.state === 1 ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '财务部') ||
					(this.str.type === 3 &&
						this.str.system === 5 &&
						this.str.superDepartmentName === '人事部')
				) {
					this.disabledInput = false
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr1 = res.data.data.next
				} else if (this.state === 2) {
					this.disabledInput = true
					this.disabledInput2 = false
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr1 = res.data.data.next
				} else if (this.state === 3) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = false
					this.disabledInput4 = false
					this.arr2 = res.data.data.next
				} else if (this.state === 4) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = true
					this.disabledInput4 = false
					this.arr3 = res.data.data.next
				} else if (this.state === 5) {
					this.disabledInput = true
					this.disabledInput2 = true
					this.disabledInput3 = true
					this.disabledInput4 = true
					var sellerInfos = res.data.data.next
					var newArr = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks
						for (var j = 0; j < shop.length; j++) {
							newArr[num] = shop[j]
							// newArr[num] = shop[j];
							num++
						}
					}
					this.arr4 = newArr
					// this.arr4 = newArr.sort((a, b) => a.order - b.order);
				}
			})
		},
		getCompanyInfo() {
			ajaxPost(Baseurl + 'companyController/selectCompanyByCompanyId', {
				id: this.str.company_id,
				type: this.str.type,
			}).then((res) => {
				if (res.data.code == 200) {
					this.companyInfo = res.data.data
				}
			})
		},
		getCompanyMoney() {
			const API =
				Baseurl + 'companyController/selectCompanyBalanceByCompanyId'
			const paramsData = { id: this.companyId }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.companyInfo = data
				}
			})
		},
		ChangeChild(value) {
			this.companyId = value
			this.getCompanyMoney()
		},
		shopChange2(value2) {
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.rid = value2.rid
			console.log(value2)
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value2.rid,
				system: 3,
				companyId: this.companyId,
			}).then((res) => {
				this.arr2 = res.data.data.next
				this.shopIds = res.data.data.shopIds
				console.log(this.arr2)
			})
		},
		shopChange3(value3) {
			console.log(value3)
			this.arr4 = []
			this.arr5 = []
			this.value4 = ''
			this.value5 = ''
			this.rid = value3.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value3.rid,
				system: 4,
				companyId: this.companyId,
			}).then((res) => {
				this.arr3 = res.data.data.next
				this.shopIds = res.data.data.shopIds
				console.log(this.arr3)
			})
		},
		shopChange4(value4) {
			console.log(value4)
			this.arr5 = []
			this.value5 = ''
			this.rid = value4.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value4.rid,
				system: 5,
				companyId: this.companyId,
			}).then((res) => {
				var sellerInfos = res.data.data.next
				var newArr = []
				var ids = []
				var num = 0
				for (var i = 0; i < sellerInfos.length; i++) {
					var shop = sellerInfos[i].countryMarks
					for (var j = 0; j < shop.length; j++) {
						newArr[num] = shop[j]
						ids[num] = shop[j].shopId
						num++
					}
				}
				this.arr4 = newArr
				this.shopIds = res.data.data.shopIds
				console.log(this.arr4)
			})
		},
		shopChange5(value5) {
			// this.sellerIds = item;
			// this.rid = ''
			this.shopIds = [value5.shopId]
			console.log(this.shopIds)
		},
		shopChange6(value6) {
			console.log(value6)
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.arr7 = []
			this.value1 = ''
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.value7 = ''
			this.companyId = value6.company_id
			this.rid = value6.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value6.rid,
				system: 1,
				companyId: this.companyId,
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr7 = data.next
					this.shopIds = data.shopIds
					this.getCompanyMoney()
				}
			})
		},
		shopChange7(value7) {
			// console.log(value7)
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.value1 = ''
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.companyId = value7.company_id
			this.rid = value7.rid
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
				rid: value7.rid,
				system: 1,
				companyId: this.companyId,
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr1 = data.next
					this.shopIds = data.shopIds
					this.getCompanyMoney()
				}
			})
		},
		Search2() {
			this.currentpage = 1
			this.Search()
		},
		Search() {
			var begin = this.ruleForm.starttime
			if (begin == null || begin == '') {
				begin = ''
			} else {
				begin =
					new Date(this.ruleForm.starttime)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.starttime)
						.toTimeString()
						.substr(0, 8)
			}
			var end = this.ruleForm.endtime
			if (end == null || end == '') {
				end = ''
			} else {
				end =
					new Date(this.ruleForm.endtime)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.endtime).toTimeString().substr(0, 8)
			}
			this.loadingStatus = true
			// shopIds: this.shopIds, companyId
			var searchobj = {
				rid: this.rid,
				page: this.currentpage,
				size: this.size,
				companyId: this.value7 || this.str.company_id,
				orderStatus: this.orderStatus,
				purchaseDemandStatus: this.purchaseDemandStatus,
				beginDate: begin,
				endDate: end,
				searchStr: this.input,
				purchaseMark: this.purchaseMark,
				channelMark: this.channelMark,
				orderMark: this.orderMark,
				internalConveyNumber: this.ruleForm.internalConveyNumber,
				conveyNumber: this.ruleForm.conveyNumber,
				purchaseStatus: this.ruleForm.domesticvalue,
				channelStatus: this.ruleForm.channelStatus,
				sku: this.ruleForm.sku,
			}
			// console.log(searchobj);
			ajaxPost(
				Baseurl + 'orderController/selectSelfBuiltOrder',
				searchobj
			).then((res) => {
				this.loadingStatus = false
				const { code, message } = res.data
				if (code === 200) {
					this.searchdata = res.data
					this.tableData = res.data.data.list
					this.tableData.forEach((item) => {
						if (!Array.isArray(item.orderChannels)) return
						item.orderChannels.forEach((key) => {
							this.$set(key, 'isActive', false)
							// key.isActive = false
						})
					})
					this.total = res.data.data.total
					this.changePurchaseStatus(this.tableData)
				} else if (code === 500) {
					this.$message.error(message)
				}
			})
		},
		handleSizeChange(val) {
			this.size = val
			this.Search()
		},
		handleCurrentChange(val) {
			this.currentpage = val
			this.Search()
		},
		// 亚马逊订单状态
		chanPurchase(val) {
			this.orderStatus = val
		},
		//采购需求状态
		changeDemand(val) {
			if (val == '未完成') {
				this.purchaseDemandStatus = '0'
			} else if (val == '已完成') {
				this.purchaseDemandStatus = '1'
			}
		},
		// 国内物流
		chanDomestic(val) {
			this.domesticvalue = val
		},
		//选择开始时间
		startTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.starttime = datetime
			//console.log(val);
		},
		// 选择结束时间
		endTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.endtime = datetime
			// console.log(val);
		},
		// 重置
		searchReset() {
			this.radioTime = ''

			this.input = ''
			this.ruleForm.Ymxvalue = ''
			this.ruleForm.demandValue = ''
			this.ruleForm.domesticvalue = ''
			this.ruleForm.channelStatus = ''
			this.ruleForm.starttime = ''
			this.ruleForm.endtime = ''
			this.ruleForm.sku = ''

			this.ruleForm.resource1 = ''
			this.ruleForm.resource2 = ''
			this.ruleForm.resource3 = ''
			;(this.purchaseMark = ''),
				(this.channelMark = ''),
				(this.orderMark = '')

			this.currentpage = 1
			this.size = 20
			this.arr1 = []
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.arr5 = []
			this.arr6 = []
			this.arr7 = []
			// this.value1 = "";
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''
			this.value5 = ''
			this.value6 = ''
			this.value7 = ''

			this.orderStatus = ''
			this.purchaseDemandStatus = ''

			this.ruleForm.internalConveyNumber = ''
			this.ruleForm.conveyNumber = ''

			var str = JSON.parse(localStorage.getItem('role'))
			this.companyId = str.company_id
			this.state = str.system
			this.rid = str.rid
			this.init()
		},
		// 操作
		operation(e) {
			this.$refs.editpanel.init(e) //子级的init
		},
		handleSelect(item) {},
		// 运单
		Domestic(content) {
			this.$refs.Waybill.init(content)
		},
		// 下载订单
		async handleDown() {},
		handleDownload() {
			ajaxPost(Baseurl + 'sellerController/getSellerByRid', {
				rid: this.str.rid,
			}).then((res) => {
				console.log(res.data.data)
				const { code, data } = res.data
				if (code === 200) {
					this.downloadOptions = [
						{
							value: 'all',
							label: '所有',
						},
					]
					data.forEach((v) => {
						console.log(v.shop_name, v.id)
						this.downloadOptions.push({
							value: v.id,
							label: v.shop_name,
						})
					})
					this.downloadDialog = true
				}
			})
		},

		handleTrue() {
			if (this.value6 && this.value) {
				this.issloading = true
				ajaxPost(
					Baseurl + 'orderController/updateOrderByAmazonOrderId',
					{
						amazonOrderId: this.value6,
						id: this.value,
					}
				).then((res) => {
					if (res.data.code == 200) {
						// console.log(res.data);
						this.$notify.info({
							title: '消息',
							message: `${res.data.data}`,
						})
						// this.$message({
						//     message: "同步订单完成",
						//     type: "success"
						// });
						this.issloading = false
						this.dialog = false
						this.value6 = ''
						this.value = ''
						searchReset()
					} else {
						this.issloading = false
						this.$message({
							message: res.data.data,
							type: 'error',
						})
					}
				})
			} else {
				this.$message.error('请检查信息是否完整')
			}
		},
		handleCancel() {
			this.$message('已取消')
			this.dialog = false
			this.value6 = ''
			this.value = ''
		},
		changePurchaseStatus(data) {
			if (!data || !data.length) return
			var param = data
			for (var j = 0; j < param.length; j++) {
				var purchaseDemands = param[j].purchaseDemands
				for (var i = 0; i < purchaseDemands.length; i++) {
					var purchaseItems = purchaseDemands[i].purchaseItems
					// for (var k = 0; k < purchaseItems.length; k++) {
					//     if (purchaseItems[k].purchaseStatus == 1) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "代采购";
					//     } else if (purchaseItems[k].purchaseStatus == 2) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已采购";
					//     } else if (purchaseItems[k].purchaseStatus == 3) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已发货";
					//     } else if (purchaseItems[k].purchaseStatus == 4) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "已签收";
					//     } else if (purchaseItems[k].purchaseStatus == 5) {
					//         param[j].purchaseDemands[i].purchaseItems[k].purchaseStatus = "退货";
					//     }
					// }
				}
			}
			this.tableData = param
		},
		calcProfitPrice(row) {
			// console.log(row)
			const {
				purchaseDemands = [],
				feeAmount = 0, // 佣金
				shipping = 0, // 国际运费
				money, // 订单金额
				refund = 0, // 退款
				refundCommission = 0, // 退款管理费
				commissionFeeAmount = 0, // 退款佣金
				// countryMarks: { countryMark }, // 国家标识
				// amountChina, // 中国价格
				platformFee, // 平台费用
				channelShipping, //运费
				totalAfterSalesFee, //售后
				tax, // 税,
				feeAmountChina, // 佣金对应的人民币
				inventoryFee, //库存成本
				refundChina = 0, // 退款对应的人民币
				refundCommissionChina = 0, // 退款管理费对应的人民币
				commissionFeeAmountChina,
				csbafeeChina,
				csbafee,
				taxChina,
			} = row
			// 采购价/成本
			let costPrice = purchaseDemands
				.reduce((total, item) => {
					return (total += item.purchaseItems.length
						? item.purchaseItems.reduce((result, key) => {
								return (result +=
									key.purchasePrice -
									key.rebatePrice -
									key.otherPrice)
						  }, 0)
						: 0)
				}, 0)
				.toFixed(2)
			this.$set(row, 'costPrice', costPrice)
			// 未转换汇率之前  (订单金额 - 佣金 - 退款 - 退款管理费)
			// 订单金额：订单金额 - 税
			const { amount = 0, amountChina = 0 } = money || {}
			let cusAmount = amount
			// if (tax) {
			//   cusAmount = (amount - tax).toFixed(2);
			// }
			this.$set(row, 'cusAmount', cusAmount)
			// 佣金
			const feeNum = (feeAmount - commissionFeeAmount).toFixed(2)
			this.$set(row, 'feeNum', feeNum)
			// 外币 - 佣金 - 退款 - 退款管理费
			const beforePrice = (
				cusAmount -
				tax -
				feeNum -
				refund -
				refundCommission -
				csbafee
			).toFixed(2)
			this.$set(row, 'beforePrice', beforePrice)
			// 汇率数据
			// const reteData = this.rate.find(item => item.countryCode === countryMark);
			/**
			 * afterRatePrice 转换汇率之后 CNY
			 * 规则：中国的价格 - 佣金对应的人民币 - 退款对应的人民币 - 退款管理费对应的人民币
			 */
			let afterRatePrice = (
				amountChina -
				feeAmountChina +
				commissionFeeAmountChina * 1 -
				refundChina -
				refundCommissionChina -
				csbafeeChina -
				taxChina
			).toFixed(2)
			// if (refund) {
			//   afterRatePrice = (beforePrice * reteData.exchangeRate).toFixed(2);
			// } else {
			//   if (amountChina) {
			//     afterRatePrice = (amountChina - feeAmountChina).toFixed(2);
			//   } else {
			//     afterRatePrice = (beforePrice * reteData.exchangeRate).toFixed(2);
			//   }
			// }
			// afterRatePrice = refund || !amountChina ? (beforePrice * reteData.exchangeRate).toFixed(2) : (amountChina - feeAmountChina).toFixed(2);
			this.$set(row, 'afterRatePrice', afterRatePrice)
			// 规则：利润 = (订单金额 - 佣金 - 退款 - 退款管理费)(换成CNY) - 采购价 - 国际运费 - 平台管理费(先为0)
			const profitPrice = (
				afterRatePrice -
				costPrice -
				shipping -
				platformFee -
				channelShipping -
				inventoryFee +
				totalAfterSalesFee * 1
			).toFixed(2)
			// console.log(profitPrice)
			this.$set(row, 'profitPrice', profitPrice)
			return profitPrice
		},
		handleSizeWaybillChange(val) {
			this.waybillSize = val
			this.uploadWaybillList()
		},
		handleCurrentWaybillChange(val) {
			this.waybillPage = val
			this.uploadWaybillList()
		},
		uploadWaybillShopChange(event) {
			this.listChannel = ListChannel[event.countryName]
			this.uploadWaybillList()
		},
		handleSelectionWaybillChange(val) {
			// console.log(val);
			checkedList = val
		},
		handleRadioChange(val) {
			this.waybillType = val
			this.waybillPage = 1
			this.waybillSize = 20
			if (!Object.keys(this.uploadWaybillShop).length) {
				this.listTableWaybill = []
				return
			}
			this.uploadWaybillList()
		},
		async uploadWaybillList() {
			const API =
				Baseurl + 'orderController/getOrderChannelByCountrySellerId'
			// const countrySellerIds = this.uploadWaybillShop.countryMarks.map(item => item.shopId);
			// if (!countrySellerIds.length) return;
			const paramsData = {
				page: this.waybillPage,
				size: this.waybillSize,
				countrySellerIds: [this.uploadWaybillShop.shopId],
				numberStatus: this.waybillType,
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			if (code === 200) {
				if (this.waybillType === '2') {
					data.list.forEach((item) => {
						item.channelName = ''
					})
				}
				this.listTableWaybill = data.list
				this.waybillTotal = data.total
				this.uploadWaybillDialog = true
			}
		},
		async updateWaybill(type) {
			if (!Object.keys(this.uploadWaybillShop).length) {
				this.$message.warning('请先选择店铺')
				return
			}
			if (!checkedList.length) {
				this.$message.warning('请先选中要上传的产品')
				return
			}
			if (type === 2) {
				const resultData = checkedList.find((item) => !item.channelName)
				if (resultData) {
					this.$message.warning('请检查所选产品的信息是否填写完整！')
					return
				}
			}
			const API = Baseurl + 'amaoznFeedUpload/orderFulfillmentFeed'
			const checkedData = checkedList.map((item) => {
				// console.log(JSON.parse(JSON.stringify(item)))
				if (item.channelName === '三态') {
					item.channelName1 = 'SFC'
				} else if (item.channelName === '燕文') {
					item.channelName1 = 'Yanwen'
				} else if (
					item.channelName === '云途' ||
					item.channelName === '云途(服装)' ||
					item.channelName === '云途A'
				) {
					item.channelName1 = 'Yun Express'
				} else if (item.channelName === '递四方') {
					if (
						item.countryName == '澳大利亚' ||
						item.countryName == '美国' ||
						item.countryName == '新加坡' ||
						item.countryName == '墨西哥'
					) {
						item.channelName1 = '4PX'
					} else {
						item.channelName1 = '递四方速递'
					}
				} else {
					item.channelName1 = item.channelName
				}
				const obj = {
					amazonOrderID: item.amazonOrderId,
					carrierName: item.channelName1,
					shippingMethod: item.channelWay,
				}
				// type 等于 1 上传运单号；等于 2 上传转单号；
				obj.shipperTrackingNumber =
					type === 1
						? item.conveyNumber || ''
						: item.transferOrderNumber || ''
				return obj
			})
			// return
			const paramsData = {
				marketInfo: JSON.stringify({
					sellerId: this.uploadWaybillShop.sellerId,
					mwsAuthToken: this.uploadWaybillShop.mwsAuthToken,
					marketplaceId: this.uploadWaybillShop.marketPlaceId,
				}),
				data: checkedData,
				rid: this.str.rid,
				type,
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			if (code === 200) {
				this.$message.success(data)
				this.uploadWaybillList()
			} else {
				this.$message.error(data)
			}
		},
		handleUpload() {
			var str = JSON.parse(localStorage.getItem('role'))
			// console.log(str.rid);
			ajaxPost(Baseurl + 'sellerController/selectSellerByRid', {
				rid: str.rid,
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.optionsUpload = data.reduce(
						(initArr, key) => [
							...initArr,
							...key.countryMarks.map((item) => ({
								sellerId: key.sellerId,
								mwsAuthToken: key.mwsAuthToken,
								...item,
							})),
						],
						[]
					)
					this.uploadWaybillDialog = true
				} else {
					this.$message.error(data)
				}
			})
		},
		getOriginalImg(item) {
			// console.log(item)
			const API = Baseurl + 'productController/selectImagesByChildSku'
			const paramsData = {
				childSku: item.sellerSKU,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data, message } = res.data
				if (code === 200) {
					this.originalImg = data
					this.originalVisible = true
				} else {
					this.$message.error(message)
				}
			})
		},
		sortByKey(array, key) {
			return array.sort(function(a, b) {
				var x = a[key]
				var y = b[key]
				return x < y ? -1 : x > y ? 1 : 0
			})
		},
		queryExternalcall(item) {
			console.log(222)
			this.tableData.forEach((item) => {
				if (!Array.isArray(item.orderChannels)) return
				item.orderChannels.forEach((key) => {
					this.$set(key, 'isActive', false)
					// key.isActive = false
				})
			})
			item.isActive = true
			window.YQV5.trackSingleF1({
				//必须，指定悬浮位置的元素ID。
				YQ_ElementId: item.conveyNumber,
				//可选，指定查询结果宽度，最小为260px，默认为470px。
				YQ_Width: 500,
				//可选，指定查询结果高度，最大为800px，默认为560px。
				YQ_Height: 600,
				//可选，指定运输商，默认为自动识别。
				YQ_Fc: '0',
				//可选，指定UI语言，默认根据浏览器自动识别。
				YQ_Lang: 'zh-CN',
				//必须，指定要查询的单号。
				// YQ_Num: "YT2018021266048349",
				YQ_Num: item.conveyNumber,
			})
		},
		queryDomesticOrderMove(num, type) {
			const API = Baseurl + 'conveyNumberQueryController/queryTrack'
			const paramsDate = { num, type, companyId: this.str.company_id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		popoverShow(type, item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			if (timer) clearTimeout(timer)
			timer = setTimeout(async () => {
				try {
					let num, channel
					if (type === 'international') {
						num = item.conveyNumber
						channel = item.type
					} else {
						num = item.internalConveyNumber
						channel = null
					}
					const data = await this.queryDomesticOrderMove(num, channel)
					if (data.status === '200') {
						this.popoverStatus = false
						this.popoverInfo = data
					} else {
						this.popoverText = data.message || '查询失败'
					}
				} catch (error) {
					this.popoverText = error || '查询失败'
				}
			}, 1000)
		},
		queryDomesticOrderClick(item) {
			const inputEle = document.createElement('input')
			inputEle.readOnly = 'readOnly'
			inputEle.style.position = 'absolute'
			inputEle.style.top = document.body.scrollTop
			inputEle.style.zIndex = '-1000'
			const appEle = document.getElementById('app')
			appEle.appendChild(inputEle)
			inputEle.setAttribute('value', item.internalConveyNumber)
			inputEle.select()
			if (document.execCommand('copy')) {
				this.$confirm('复制成功，点击确定跳转快递100页面', '提示').then(
					() => {
						window.open('https://www.kuaidi100.com/')
					}
				)
			}
			appEle.removeChild(inputEle)
		},
	},
}
</script>
<style lang="scss" scoped>
.NewAddsTopBox {
	border-top: 1px dashed #ccc;
	padding-top: 10px;
}
.NewAddsTop {
	display: flex;
	.OrderTit {
		height: 30px;
		width: 50%;
		padding-left: 15px;
		font-weight: bold;
		font-size: 17px;
	}
	.Remove {
		width: 50%;
		text-align: right;
		padding-right: 20px;
		font-size: 25px;
		i {
			cursor: pointer;
			border-radius: 15px;
			&:hover {
				transition: all 1s;
				/* background: rgba(0, 0, 0, 0.5); */
				transform: rotate(270deg);
				color: #409eff;
			}
		}
	}
	.LeftUp {
		width: 30%;
		text-align: center;
		.avatar-uploader {
			text-align: center;
			::v-deep {
				.el-upload {
					border: 1px dashed #d9d9d9;
					border-radius: 6px;
					cursor: pointer;
					position: relative;
					overflow: hidden;
					&:hover {
						border-color: #409eff;
					}
				}
			}
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
			height: 178px;
			line-height: 178px;
			text-align: center;
		}
		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}
	}
	.RightInp {
		width: 70%;
		.el-form-item {
			margin-bottom: 10px;
		}
		.el-form-item__content {
			display: flex;
			width: 300px;
		}
	}
}
.NewAddsBottom {
	margin-top: 15px;
	padding: 10px;
	::v-deep {
		.custom {
			width: 53px !important;
			height: 29px;
			line-height: 28px;
			border: 1px solid #dcdfe6;
			border-radius: 4px;
			background-color: #f5f7fa;
			color: #909399;
			vertical-align: middle;
			display: table-cell;
		}
	}
}
.RRR {
	color: red;
}
.FBMOrder {
	width: 98%;
	position: relative;

	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 120px);
			}
		}
	}
	.el-table {
		font-size: 12px;
	}
	.FBMOrder_top {
		overflow: hidden;
		border-bottom: 1px #eee solid;
		h3 {
			float: left;
			margin-bottom: 20px;
		}
		div {
			float: right;
		}
	}
	.el-tag--dark {
		border: 0;
	}
	::v-deep {
		.el-form-item__label {
			width: 120px;
			// text-align: center;
		}
	}
	.order_list {
		position: relative;
		// overflow: hidden;
		.search-result {
			overflow: hidden;
			background: #f9f3f3;
			.right {
				float: right;
			}
		}
		.search-result-text {
			font-size: 14px;
			color: #606266;
			width: 230px;
			line-height: 40px;
			float: left;
			span {
				color: #f56c6c;
				font-size: 16px;
			}
		}
		.cell {
			.scope_img {
				display: initial;
			}
		}
	}
	.el-table {
		overflow: initial;
	}
	.el-table__body-wrapper {
		overflow: initial;
	}
	a {
		color: #409eff;
	}
	.details {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.details_left {
		width: 30%;
		text-align: center;
	}
	.details_right {
		width: 70%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
		z-index: 99;
	}
	.scope_img img {
		width: 55px;
		height: 55px;
	}
	.Memo {
		width: 25px;
		height: 25px;
	}
	.Memo1 {
		width: 17px;
		height: 19px;
	}
}
</style>
